import XmlDomUtils from '../../../utils/XmlDomUtils';
import settingsReader from '../../../../store/readHelpers/SettingsReader';

const textEntryParser = {
    parse(interactionElement) {
        const attributes = XmlDomUtils.getAttributes(interactionElement);
        const styleAttr = attributes['inspera:style'];
        const styles = {};
        if (styleAttr) {
            const cssRules = styleAttr.split(';');

            for (let i = 0; i < cssRules.length; i++) {
                if (cssRules[i].trim() !== '') {
                    const rule = cssRules[i].split(':');
                    styles[rule[0].trim()] = rule[1].trim();
                }
            }
        }
        const inputFieldWidthAttr = attributes['inspera:inputFieldWidth'];
        const keyword = attributes['data-keyword'];
        const expectedLengthAttr = attributes.expectedLength;

        return {
            expectedLength: inputFieldWidthAttr ? Number.parseInt(inputFieldWidthAttr, 10) : Number.parseInt(expectedLengthAttr, 10),
            useInputMaxLength: attributes['inspera:useInputMaxLength'] === 'true',
            expandAutomatically: settingsReader.isExpandableTextFieldEnabled() && attributes['inspera:expandAutomatically'] === 'true',
            expectedDecimals: Number.parseInt(attributes['inspera:expectedDecimals'], 10),
            interactionType: attributes['inspera:type'] ? attributes['inspera:type'] : '',
            style: styles,
            keyword,
        };
    },
};

export default textEntryParser;
